const tabletBreakpoint = window.matchMedia( '(max-width: 1199px)' );
const bodyElement = document.body;
const header = document.querySelector( '.page-header' )
const menu = document.querySelector( '.js-menu-header' )
const mobileMenuElements = document.querySelectorAll( '.c-menu-header-li--0.menu-item-has-children' )
const languageButton = document.querySelector( '.page-header__language-switcher' );
const hamburgerButton = header.querySelector( '.js-mobile-menu-button' );
const searchPopup = header.querySelector( '.js-search-popup' );
const searchButton = header.querySelector( '.js-search-open-popup' );
const searchInput = header.querySelector( '.js-search-input' );
const searchInputCloseButton = header.querySelector( '.js-search-clear' );
const searchInputIcon = header.querySelector( '.c-form__input-icon' );
const menuItemsWithSubmenu = header.querySelectorAll( '.js-menu-header-has-children.c-menu-header-li--main' )
const menuItemsFirstLevel = header.querySelectorAll( '.c-menu-header-li--main' )


let buttonsWrapper = null;


/**
 * Function to display custom buttons when a specific event matches
 *
 * @param { MediaQueryList } breakpoint The MediaQueryListEvent that triggers the button display
 */
const loadButtons = ( breakpoint ) => {


	if ( breakpoint.matches ) {

		const buttons = header.querySelectorAll( '.js-custom-button' );

		if ( buttons ) {

			buttons.forEach( button => button.style.display = 'flex' )

		}

	}


}

/**
 * Function that triggers a mobile menu when a specified breakpoint is matched.
 *
 */
const mobileTrigger = () => {


	hamburgerButton.addEventListener( 'click', ( e ) => {

		const scrollPosition = window.scrollY

		hamburgerButton.classList.toggle( 'menu-toggle-button--active' )
		menu.classList.toggle( 'c-menu-header--open' );

		if ( hamburgerButton.classList.contains( 'menu-toggle-button--active' ) ) {

			bodyElement.classList.add( 'menu-is-active' );
			document.documentElement.classList.add( 'no-scroll-animation' );
			bodyElement.style.top = `-${scrollPosition}px`;

			if ( languageButton ) {

				languageButton.classList.remove( 'active' )

			}
			if ( searchPopup ) {

				searchPopup.classList.remove( 'is-active' )
				searchButton.classList.remove( 'page-header__search-button--open' )

			}


		} else {

			const scrollY = bodyElement.style.top;
			bodyElement.classList.remove( 'menu-is-active' );
			bodyElement.style.top = '';
			window.scrollTo( 0, parseInt( scrollY || '0' ) * -1 );
			document.documentElement.classList.remove( 'no-scroll-animation' );

		}

		e.preventDefault();

	} );


}


/**
 * Adds blur effect on hover for menu items.
 * When a menu item is hovered, it adds the 'menu-is-active' class to the body element,
 * adds the 'no-scroll-animation' class to the document element, and adjusts the scroll position.
 * When the mouse leaves the menu item, it removes the 'menu-is-active' class, resets the scroll position,
 * removes the 'no-scroll-animation' class, and scrolls to the original position.
 * @param {MediaQueryList} breakpoint - The MediaQueryList object representing the breakpoint where the mobile menu should be triggered.
 */
const addBlurEffectOnHover = ( breakpoint ) => {

	const langButton = document.querySelectorAll( '.page-header__language-switcher' );

	/**
	 * Applies hover effect to menu items.
	 *
	 * @param {NodeListOf<Element>} menuItems - The array of menu item elements.
	 */
	const applyHoverEffect = ( menuItems ) => {


		if ( menuItems && !breakpoint.matches ) {

			menuItems.forEach( ( item ) => {


				item.addEventListener( 'mouseenter', () => {

					const scrollPosition = window.scrollY
					bodyElement.classList.add( 'menu-is-active' );
					document.documentElement.classList.add( 'no-scroll-animation' );
					bodyElement.style.top = `-${scrollPosition}px`;


				} );

				item.addEventListener( 'mouseleave', () => {

					const scrollY = bodyElement.style.top;
					bodyElement.classList.remove( 'menu-is-active' );
					bodyElement.style.top = '';
					window.scrollTo( 0, parseInt( scrollY || '0' ) * -1 );
					document.documentElement.classList.remove( 'no-scroll-animation' );


				} );

			} )

		}

	}
	applyHoverEffect( langButton )

}


/**
 * Function to handle the menu dropdown elements.
 *
 * @param {MediaQueryList} breakpoint - The MediaQueryList object representing the breakpoint where the mobile menu should be triggered. * @function menuDropdownElements
 */
const menuDropdownElements = ( breakpoint ) => {

	menuItemsFirstLevel.forEach( item => {

		let openTimeout;
		let closeTimeout;

		item.addEventListener( 'mouseenter', () => {


			if ( breakpoint.matches && item.classList.contains( 'js-menu-header-has-children' ) ) {


				const dropdown = item.querySelector( '.js-header-submenu' );

				if ( dropdown ) {


					clearTimeout( closeTimeout )
					openTimeout = setTimeout( () => {

						bodyElement.classList.add( 'menu-is-active' );
						header.classList.add( 'megamenu-is-open' );
						dropdown.classList.add( 'active' )


					}, 300 );

				}


			}


		} );

		item.addEventListener( 'mouseleave', () => {


			if ( breakpoint.matches && item.classList.contains( 'js-menu-header-has-children' ) ) {

				const dropdown = item.querySelector( '.js-header-submenu' );

				if ( dropdown ) {


					clearTimeout( openTimeout );

					closeTimeout = setTimeout( () => {

						bodyElement.classList.remove( 'menu-is-active' );
						header.classList.remove( 'megamenu-is-open' );
						dropdown.classList.remove( 'active' )


					}, 500 );

				}

			}

		} );

	} );


}

/**
 * Function to add or remove a CSS class on scroll.
 *
 * @function addClassOnScroll
 */
const addClassOnScroll = () => {

	const scrollTrigger = document.createElement( 'div' );
	scrollTrigger.style.position = 'absolute';
	scrollTrigger.style.height = '1px';
	scrollTrigger.style.width = '1px';
	scrollTrigger.style.top = '30px';
	bodyElement.appendChild( scrollTrigger );

	const observer = new IntersectionObserver( ( entries ) => {

		entries.forEach( entry => {

			if ( entry.isIntersecting ) {

				header.classList.remove( 'page-header--scrolled' );

			} else {

				header.classList.add( 'page-header--scrolled' );

			}

		} );

	}, { threshold: [0] } );
	observer.observe( scrollTrigger );

}


/**
 * Function to handle the search header functionality.
 *
 * @function searchHeader
 */
const searchHeader = () => {


	if ( !searchButton ) {


		return;

	}
	const searchClose = header.querySelectorAll( '.js-search-close-popup' );


	searchButton.addEventListener( 'click', ( e ) => {

		e.preventDefault();

		const scrollPosition = window.scrollY
		searchButton.classList.toggle( 'page-header__search-button--open' );
		searchPopup.classList.toggle( 'is-active' );

		if ( searchPopup.classList.contains( 'is-active' ) ) {

			bodyElement.classList.add( 'menu-is-active', 'search-is-open' );
			document.documentElement.classList.add( 'no-scroll-animation' );
			bodyElement.style.top = `-${scrollPosition}px`;

			if ( languageButton ) {

				languageButton.classList.remove( 'active' )

			}
			if ( hamburgerButton ) {

				menu.classList.remove( 'c-menu-header--open' )
				hamburgerButton.classList.remove( 'menu-toggle-button--active' )

			}

		} else {

			const scrollY = bodyElement.style.top;
			setTimeout( () => {

				bodyElement.classList.remove( 'menu-is-active', 'search-is-open' );

			}, 500 );
			bodyElement.style.top = '';
			window.scrollTo( 0, parseInt( scrollY || '0' ) * -1 );
			document.documentElement.classList.remove( 'no-scroll-animation' );

		}

	} );
	searchClose.forEach( ( close ) => {

		close.addEventListener( 'click', ( e ) => {

			e.preventDefault();
			const scrollY = bodyElement.style.top;
			searchButton.classList.remove( 'page-header__search-button--open' );
			searchPopup.classList.remove( 'is-active' );
			setTimeout( () => {

				bodyElement.classList.remove( 'menu-is-active', 'search-is-open' );

			}, 500 );

			header.classList.remove( 'search-is-open' );
			languageButton.classList.remove( 'active' );
			hamburgerButton.classList.remove( 'menu-toggle-button--active' );
			menu.classList.remove( 'c-menu-header--open' );
			bodyElement.style.top = '';
			window.scrollTo( 0, parseInt( scrollY || '0' ) * -1 );
			document.documentElement.classList.remove( 'no-scroll-animation' );

		} );

	} );

}


/**
 * Toggles the behavior of the mobile menu based on the current breakpoint.
 * If the mobile menu elements exist, it adds the necessary functionality to show/hide submenus and a "back" button.
 * If the mobile breakpoint matches, it modifies the elements to include the additional functionality.
 * If the mobile breakpoint does not match, it removes the additional functionality from the elements.
 * @param {MediaQueryList} breakpoint - The MediaQueryList object representing the breakpoint where the mobile menu should be triggered.
 */
const menuMobile = ( breakpoint ) => {

	if ( mobileMenuElements ) {

		if ( breakpoint.matches ) {


			mobileMenuElements.forEach( ( element ) => {


				const children = element.querySelector( '.js-header-submenu' );
				const menuElTitle = children.previousElementSibling.querySelector( 'span' ).innerText;
				const backButton = document.createElement( 'button' );
				const span = document.createElement( 'span' );
				backButton.classList.add( 'c-menu-header__back-button' );
				span.innerText = menuElTitle;
				backButton.appendChild( span );
				children.prepend( backButton );

				element.addEventListener( 'click', ( e ) => {

					e.stopPropagation();

					mobileMenuElements.forEach( ( el ) => {

						el.querySelectorAll( '.c-menu-header-sub' ).forEach( ( submenu ) => {

							submenu.classList.remove( 'c-menu-header-sub--open' );

						} );


					} );


					children.classList.add( 'c-menu-header-sub--open' );

				} );

				backButton.addEventListener( 'click', ( e ) => {

					e.stopPropagation();
					const backButtonParent = backButton.parentNode;
					backButtonParent.classList.remove( 'c-menu-header-sub--open' );

				} );

			} );

		} else {


			document.querySelectorAll( '.c-menu-header__back-button' ).forEach( ( backButton ) => {

				backButton.remove()

			} )


		}

	}

};

/**
 * Moves buttons to the sidebar or to the desktop header depending on the screen size.
 * @param {MediaQueryList} breakpoint - The MediaQueryList object representing the breakpoint where the mobile menu should be triggered.
 */
const moveButtonToSidebar = ( breakpoint ) => {

	const buttonsToMove = document.querySelectorAll( '.js-custom-button' );
	const menuNav = document.querySelector( '.js-menu-header' );

	if ( buttonsToMove.length ) {

		if ( breakpoint.matches ) {


			if ( !buttonsWrapper ) {

				buttonsWrapper = document.createElement( 'div' );
				buttonsWrapper.classList.add( 'c-menu-header__buttons-wrapper' );
				menuNav.appendChild( buttonsWrapper );

			}

			buttonsToMove.forEach( ( button ) => {

				buttonsWrapper.appendChild( button );

			} );

		} else {

			const targetElement = document.querySelector( '.js-mobile-menu-button' );
			const desktopButtonsWrapper = document.querySelector( '.page-header-buttons' );

			buttonsToMove.forEach( ( button ) => {

				desktopButtonsWrapper.insertBefore( button, targetElement );

			} );

			if ( buttonsWrapper && !buttonsWrapper.hasChildNodes() ) {

				buttonsWrapper.remove();
				buttonsWrapper = null;

			}

		}

	}

};

/**
 * A function that handles the behavior of the language button on mobile devices.
 *
 * @function languageButtonMobile
 */
const languageButtonMobile = () => {

	if ( languageButton ) {

		if ( tabletBreakpoint.matches ) {

			languageButton.addEventListener( 'click', () => {

				languageButton.classList.toggle( 'active' )


				if ( languageButton.classList.contains( 'active' ) ) {

					menu.classList.remove( 'c-menu-header--open' )
					hamburgerButton.classList.remove( 'menu-toggle-button--active' )
					bodyElement.classList.add( 'menu-is-active' )

				} else {

					bodyElement.classList.remove( 'menu-is-active' )

				}
				searchButton.classList.remove( 'page-header__search-button--open' );
				searchPopup.classList.remove( 'is-active' );


			} )

		}

	}

}

/**
 * Set the height of the language list.
 */
const setLangListHeight = () => {

	const langList = document.querySelector( '.language-switcher__list' );
	if ( langList ) {

		document.documentElement.style.setProperty( '--lang-list-total-height', `${langList.scrollHeight}px` );

	}

}


/**
 * Sets the height of submenus based on the content.
 *
 * @function setSubmenuHeight
 *
 * @return {void}
 */
const setSubmenuHeight = () => {

	let maxHeight = 0;
	const maxHeightValues = [];

	if ( menuItemsWithSubmenu ) {

		menuItemsWithSubmenu.forEach( ( menuItem, index ) => {

			const submenu = menuItem.querySelector( '.js-header-submenu' );
			maxHeightValues[ index ] = submenu.scrollHeight;

		} );
		maxHeight = Math.max( ...maxHeightValues );
		document.documentElement.style.setProperty( '--submenu-global-height', `${maxHeight}px` );

	}

};

/**
 * Sets the height of the top bar element dynamically.
 * This function finds the top bar element with the class 'page-header__topbar'
 * and updates the CSS variable '--topbar-height' with the height of the element.
 */
const setTopbarHeight = () => {

	const topbar = document.querySelector( '.page-header__topbar' )

	if ( topbar ) {

		document.documentElement.style.setProperty( '--topbar-height', `${topbar.scrollHeight}px` );

	}

};


/**
 * Sets up an observer for the search bar height and updates the CSS variable '--searchbar-total-height' accordingly.
 * @function setupSearchbarHeightWithObserver
 */
const setupSearchbarHeightWithObserver = () => {

	const searchbarElement = header.querySelector( '.js-search' );
	/**
	 * Sets the height of the search bar.
	 *
	 * @function setSearchbarHeight
	 * @return {void}
	 */
	const setSearchbarHeight = () => {

		const form = searchbarElement.querySelector( 'form' );

		if ( form ) {


			if ( searchbarElement.classList.contains( 'c-ajax-search--on' ) ) {

				document.documentElement.style.setProperty( '--searchbar-total-height', `${searchbarElement.scrollHeight}px` );


			} else {

				document.documentElement.style.setProperty( '--searchbar-total-height', `${form.scrollHeight}px` );


			}

		}

	}


	if ( searchbarElement ) {

		setSearchbarHeight();

		const observer = new MutationObserver( setSearchbarHeight );
		const observerConfig = {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class']
		}
		observer.observe( searchbarElement, observerConfig );

	}


}


/**
 * searchResultsObserver represents an observer for monitoring changes in the search results and search input field.
 *
 * @function searchResultsObserver
 * @return {void}
 */
const searchResultsObserver = () => {

	const resultsTargetNode = document.querySelector( '.js-search-results' );
	const resultsConfig = { childList: true, subtree: true };

	/**
	 * Updates the quantity labels of search result buttons based on changes in the mutation list.
	 * @param {MutationRecord[]} mutationList - The list of mutations to be observed.
	 */
	const resultsCallback = ( mutationList ) => {

		const resultItems = document.querySelectorAll( '.js-search-list-item' )
		const allButton = document.querySelector( '.js-search-nav-link[data-id="all"]' )
		const categoryButtons = document.querySelectorAll( '.js-search-nav-link' )

		for ( const mutation of mutationList ) {


			if ( mutation.type === 'childList' ) {

				allButton.querySelector( '.c-button__label--quantity' ).innerText = resultItems.length
				categoryButtons.forEach( ( button ) => {

					const buttonLabel = button.querySelector( '.c-button__label--quantity' )

					if ( button.dataset.id === 'all' ) {

						if ( resultItems[ 0 ].dataset.id !== 'nothing' ) {

							buttonLabel.innerText = resultItems.length;

						} else {

							buttonLabel.innerText = 0;

						}


					} else {

						const category = button.dataset.id;
						const categoryItems = document.querySelectorAll( `.js-search-list-item[data-id="${category}"]` );
						button.querySelector( '.c-button__label--quantity' ).innerText = categoryItems.length;

					}

				} )

			}

		}

	};

	const observer = new MutationObserver( resultsCallback );
	observer.observe( resultsTargetNode, resultsConfig );

	const searchTargetNode = document.querySelector( '.js-search' );
	const searchConfig = { attributes: true };

	/**
	 * Callback function for handling mutations in search results.
	 * @param {Array} mutationsList - List of mutations.
	 */
	const searchCallback = ( mutationsList ) => {

		const categoryButtons = document.querySelectorAll( '.js-search-nav-link' )
		// const resultsWrapper = document.querySelector( '.js-search-results' )

		const parentPlaceholderList = document.createElement( 'div' );
		parentPlaceholderList.classList.add( 'c-results--placeholder' )

		for ( let i = 0; i < 3; i++ ) {

			const placeholderList = document.createElement( 'div' );
			parentPlaceholderList.appendChild( placeholderList );

		}


		for ( const mutation of mutationsList ) {

			if ( mutation.type === 'attributes' && mutation.attributeName === 'class' ) {

				const classList = mutation.target.classList;
				const formNav = document.querySelector( '.c-form-nav' )

				if ( classList.contains( 'c-ajax-search--on' ) ) {

					formNav.classList.remove( 'disabled' )
					categoryButtons.forEach( ( button ) => {

						button.classList.remove( 'disabled' )


					} )

				} else {

					formNav.classList.add( 'disabled' )
					categoryButtons.forEach( ( button ) => {

						button.classList.add( 'disabled' )
						button.querySelector( '.c-button__label--quantity' ).innerText = 0;


					} )

				}

			}

		}

	};

	const searchObserver = new MutationObserver( searchCallback );
	searchObserver.observe( searchTargetNode, searchConfig );

}

/**
 * Attaches event listeners to search input for changing the color of the search icon.
 *
 * @function searchIconColor
 */
const searchIconColor = () => {

	searchInput.addEventListener( 'focus', () => {

		searchInputIcon.classList.add( 'c-form__input-icon--active' );

	} );

	searchInput.addEventListener( 'blur', () => {

		if ( searchInput.value === '' ) {

			searchInputIcon.classList.remove( 'c-form__input-icon--active' );

		}

	} );

	searchInputCloseButton.addEventListener( 'click', () => {

		searchInputIcon.classList.remove( 'c-form__input-icon--active' );

	} )


}


export {
	loadButtons,
	addClassOnScroll,
	addBlurEffectOnHover,
	searchHeader,
	mobileTrigger,
	menuMobile,
	moveButtonToSidebar,
	languageButtonMobile,
	searchResultsObserver,
	searchIconColor,
	setLangListHeight,
	setupSearchbarHeightWithObserver,
	setSubmenuHeight,
	menuDropdownElements,
	setTopbarHeight,
};

